import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ForgotPasswordService } from '@shared/services/forgot-password.service';
import { SnackbarFactory } from '../../../shared/services';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
  public formGroup = new FormGroup({
    username: new FormControl('', [Validators.required]),
  });

  constructor(
    public router: Router,
    public dialogRef: MatDialogRef<ForgotPasswordComponent>,
    public forgotPwdService: ForgotPasswordService,
    private translate: TranslateService,
    private snackBar: SnackbarFactory,
    @Inject(MAT_DIALOG_DATA) public data: { username: string },
    @Inject('EMAIL_SERVER_ACTIVE') public EMAIL_SERVER_ACTIVE: boolean
  ) {
    this.formGroup.patchValue({ username: data.username });
  }

  onSubmit() {
    const username = this.formGroup.controls.username.value;

    let navigateToNextPage = () => {
      this.dialogRef.close();
      this.router.navigate(['/forgot-password/confirmation'], {
        queryParams: { username: username },
      });
    }

    if (this.EMAIL_SERVER_ACTIVE) {
      this.forgotPwdService.requestPwdChange(username, false).subscribe({
        next: (res) => {
          navigateToNextPage();
        },
        error: (err) => {
          this.snackBar.showButtonSnackbar(err)
        },
      });
    }
    else {
      navigateToNextPage();
    }
  }

}
